class PetzBrandDirectory extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-petz-brand-search]');
    this.clearButton = this.querySelector('[data-petz-brand-clear]');
    this.status = this.querySelector('[data-petz-brand-status]');
    this.alphabet = this.querySelector('[data-petz-brand-alphabet]');
    this.empty = this.querySelector('[data-petz-brand-empty]');
    this.showAllButton = this.querySelector('[data-petz-brand-show-all]');
    this.groups = [...this.querySelectorAll('[data-petz-brand-group]')];
    this.items = [...this.querySelectorAll('[data-petz-brand-item]')];

    if (!this.input || !this.items.length) return;

    this.input.addEventListener('input', () => this.filter());
    this.clearButton?.addEventListener('click', () => {
      this.input.value = '';
      this.filter();
      this.input.focus();
    });
    this.showAllButton?.addEventListener('click', () => {
      this.input.value = '';
      this.filter();
      this.querySelector('[data-petz-brand-group]')?.scrollIntoView();
    });
  }

  filter() {
    const query = this.input.value.trim().toLocaleLowerCase();
    let visible = 0;

    this.items.forEach((item) => {
      const matches = !query || item.dataset.petzBrandName.includes(query);
      item.hidden = !matches;
      if (matches) visible += 1;
    });

    this.groups.forEach((group) => {
      group.hidden = !group.querySelector('[data-petz-brand-item]:not([hidden])');
    });

    if (this.clearButton) this.clearButton.hidden = !query;
    if (this.alphabet) this.alphabet.hidden = Boolean(query);
    if (this.empty) this.empty.hidden = visible !== 0;
    if (this.status) {
      this.status.textContent = query
        ? this.status.dataset.resultTemplate.replace('{count}', visible).replace('{query}', this.input.value.trim())
        : '';
    }
  }
}

if (!customElements.get('petz-brand-directory')) {
  customElements.define('petz-brand-directory', PetzBrandDirectory);
}
